import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../services/auth';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const result = await authService.login(email, password);

      if (!result.user.isActive) {
        setError('Account is deactivated. Please contact support.');
        authService.logout();
        return;
      }

      navigate('/');
    } catch (err: any) {
      setError(err.message || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-content bg-white">
      <div className="w-full max-w-lg mx-auto p-8">
        <div className="bg-white border border-heynay-border rounded-[48px] p-12 shadow-lg">
          {/* Header */}
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-heynay-dark-gray mb-2">Login to Admin Portal</h2>
            <p className="text-heynay-gray font-medium text-sm">Please enter your login details</p>
          </div>

          {/* Error Alert */}
          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-xl mb-6">
              {error}
            </div>
          )}

          {/* Form */}
          <form onSubmit={handleSubmit}>
            {/* Email */}
            <div className="mb-6">
              <label htmlFor="email" className="block text-heynay-gray font-medium mb-2 pl-3 text-sm">
                Email Address
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="example@email.com"
                required
                disabled={loading}
                className="w-full border border-heynay-border rounded-2xl px-5 py-4 text-lg focus:outline-none focus:ring-2 focus:ring-heynay-blue focus:border-transparent disabled:opacity-50"
              />
            </div>

            {/* Password */}
            <div className="mb-6">
              <label htmlFor="password" className="block text-heynay-gray font-medium mb-2 pl-3 text-sm">
                Password
              </label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Minimum 8 characters..."
                required
                disabled={loading}
                className="w-full border border-heynay-border rounded-2xl px-5 py-4 text-lg focus:outline-none focus:ring-2 focus:ring-heynay-blue focus:border-transparent disabled:opacity-50"
              />
            </div>

            {/* Submit Button */}
            <div className="mt-10">
              <button
                type="submit"
                disabled={loading}
                className="w-full bg-heynay-blue text-white font-bold py-4 px-6 rounded-3xl hover:opacity-90 transition-opacity disabled:opacity-60 disabled:cursor-not-allowed"
              >
                {loading ? 'Logging in...' : 'Log in'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
